module.exports = __webpack_public_path__ + "media/images/landing/beyond_open_access-f20411cd3a5d57eebfe35edb1f80ebbe.png";